export default{
    matterManage:{
        showMaterialsByCondition:'material/display/showMaterialsByCondition',/* 素材管理列表 */
        publish:'material/promotion/publish',/* 创建/发布营销素材 */
        modify:'material/promotion/modify',/* 编辑营销素材 */
        create:'/material/goods/create',/* 创建/发布商品素材 */
        edit:'material/goods/edit',/* 编辑商品素材 */
        showLogs:'material/display/showLogs',/* 日志 */
        delete:'material/promotion/delete',/* 删除接口 */
        revoke:'material/promotion/revoke',/* 撤回接口 */
        top:'/material/display/top',/* 置顶 */
        untop:'/material/display/untop',/* 取消置顶 */
        preview:'material/promotion/preview',/* 预览 */
        goodsList:'/material/goods/goodsList',/* 推荐商品 */
        addVideo:'/base/file/mgmt/addVideo/',/* 视频上传地址 拼接videoSize*/
    }
}